<button id="dynamic" style="display: none">Open Gallery</button>
<button id="reini" (click)="reini()" style="display: none">initiate</button>

<div *ngIf="title != ''">


  <section class="u-clearfix u-section-1" id="sec-03dc">
    <div class="u-clearfix u-sheet u-sheet-1">
      <img class="u-expanded-width-xs u-image u-image-default u-image-1" src="../../assets/images/work/879fa54bacb4e95fb1ca1e8427649dc81.png" alt="" data-image-width="650" data-image-height="252">
      <h1 class="heading u-align-center-sm u-align-center-xs u-text u-text-default u-text-palette-3-dark-2 u-text-1"> {{title | split}}<b>{{title | rest}}</b>
      </h1>
      <p class="u-align-center u-text u-text-2">{{description}}</p>
      <img class="u-expanded-width-xs u-image u-image-default u-image-2" src="../../assets/images/work/879fa54bacb4e95fb1ca1e8427649dc82.png" alt="" data-image-width="650" data-image-height="252">
    </div>
  </section>

<div class="container">
  <ul class="card-columns flexbox" id="lightgallery">
    <li attr.data-src="../../assets/images/uploads/{{ item.image }}" class="card" *ngFor="let item of imageData">
      <img
        class="card-img-top"
        src="../../assets/images/uploads/{{ item.image }}"
        alt="Card image top"
      />
    </li>
  </ul>
</div>

<div *ngIf="title == ''" id="container-loader">
  <div class="divider" aria-hidden="true"></div>
  <p class="loading-text" aria-label="Loading">
    <span class="letter" aria-hidden="true">L</span>
    <span class="letter" aria-hidden="true">o</span>
    <span class="letter" aria-hidden="true">a</span>
    <span class="letter" aria-hidden="true">d</span>
    <span class="letter" aria-hidden="true">i</span>
    <span class="letter" aria-hidden="true">n</span>
    <span class="letter" aria-hidden="true">g</span>
  </p>
</div>
